export default __webpack_public_path__ + "static/media/privecy-icon.37ca65f3.svg";